export default __webpack_public_path__ + "static/media/logo.664613b4.png";